export async function getCurrentUsage({ FLOWISE_BASE, apiKey }) {
    const url = `${FLOWISE_BASE}/organization/get-current-usage`;
    const res = await fetch(url, {
        method: 'GET',
        headers: { Authorization: `Bearer ${apiKey}` },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(json.message || 'getting error while getting current usage');
        err.details = json;
        throw err;
    }

    return { ok: true, data: json };
}

export async function canUploadFile(fileSizeMB, FLOWISE_BASE, apiKey) {
    const userUsage = await getCurrentUsage({
        FLOWISE_BASE,
        apiKey: apiKey,
    });

    const { usage, limit } = userUsage.data.storage;

    if (usage >= limit) {
        return { ok: false, message: "Storage limit reached. Cannot upload more files." };
    }

    if (usage + fileSizeMB > limit) {
        return { ok: false, message: "Uploading this file exceeds storage limit." };
    }

    return { ok: true };
}

export async function uploadFile({ FLOWISE_BASE, documentStoreId, apiKey, formData }) {
    const url = `${FLOWISE_BASE}/document-store/upsert/${documentStoreId}`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { Authorization: `Bearer ${apiKey}` },
        body: formData
    });

    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(json.message || 'Flowise upload failed');
        err.details = json;
        throw err;
    }

    return { ok: true, data: json };
}

export async function fetchDocumentsAPI({ FLOWISE_BASE, documentStoreId, apiKey }) {
    const res = await fetch(`${FLOWISE_BASE}/document-store/store/${documentStoreId}`, {
        headers: { Authorization: `Bearer ${apiKey}` }
    });
    return res.json();
}

export async function deleteLoader({ FLOWISE_BASE, documentStoreId, loaderId, apiKey }) {
    const res = await fetch(`${FLOWISE_BASE}/document-store/loader/${documentStoreId}/${loaderId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${apiKey}` }
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok) {
        const err = new Error(json.message || "Flowise delete failed");
        err.details = json;
        throw err;
    }

    return json;
}




// WEBPACK FOOTER //
// ./src/utils/flowiseService.js